module.exports = __webpack_public_path__ + "img/ennetix-users-tab5.789a43e7.png";